//  Controller Scenes
//
// Work in progress
// => Phase 2
//

//
// Fine for Minificaiton
//
(function() {
    'use strict';

angular.module('app.controllers.scenes', ['dndLists'])
    .service("SceneOverviewService", ['__SceneBase', 'versionMappingService', 'f_User',
        function(__SceneBase, versionMappingService, f_User) {
            var scenesRefreshApiCall;

            function init() {
                versionMappingService.registerFunction({
                    name: 'getScenes',
                    version: '0.0.0.0',
                    func: function () {return __SceneBase.$getAll().$asPromise();}
                });

                versionMappingService.registerFunction({
                    name: 'getScenes',
                    version: '1.5.0.0',
                    func: function () { return __SceneBase.$getScenesOverview().$asPromise();}
                });

                versionMappingService.registerFunction({
                    name: 'refreshScenes',
                    version: '0.0.0.0',
                    func: function () {return 'GetAllScenes';}
                });

                versionMappingService.registerFunction({
                    name: 'refreshScenes',
                    version: '1.5.0.0',
                    func: function () { return 'GetScenesOverview';}
                });
            }

            function activateRefreshOfScenes(apiCall) {
                scenesRefreshApiCall = apiCall;
            }

            function deactivateRefreshOfScenes() {
                scenesRefreshApiCall = undefined;
            }

            function cancelRefreshOfScenes() {
                if (scenesRefreshApiCall !== undefined) {
                    scenesRefreshApiCall.$cancelRequest();
                }
            }

            function updateUiPermissions(scene) {
                if (!scene.$UI) {
                    scene.$UI = {};
                }

                const userLevel = f_User.getUserLevel();
                /* normaly API will filter non readable */
                let canView = (scene.UserLevelRead >= userLevel ? true : false);
                scene.$UI.canView = canView;

                /* If UserLevelWrite > userLevel, we can't write it */
                let canWrite = (scene.UserLevelWrite > userLevel ? false : true);
                scene.$UI.canWrite = canWrite;
            }

            return {
                init: init,
                activateRefreshOfScenes: activateRefreshOfScenes,
                deactivateRefreshOfScenes: deactivateRefreshOfScenes,
                cancelRefreshOfScenes: cancelRefreshOfScenes,
                updateUiPermissions: updateUiPermissions
            };
        }
    ])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('scenes', {
                parent: 'site',
                url: '/scenes',
                templateUrl: 'views/scene/list.html',
                controller: 'ScenesCtrl',
                resolve: {
                    scenes: function (versionMappingService, SceneOverviewService) {
                        'ngInject';

                        SceneOverviewService.init();
                        return versionMappingService.recallFunction('getScenes')
                        .then(function(func) {
                            return func();
                        });
                    }

                },
                breadcrumb: {
                    initialState: true,
                    name: 'NAV_Scenes'
                },
                infoGuide : {
                    state: 'sceneList'
                },
            })
            .state('scenesSort', {
                parent: 'site',
                url: '/scenes/sort',
                templateUrl: 'views/scene/sort-list.html',
                controller: 'ScenesSortCtrl',
                resolve: {
                    scenes: function (versionMappingService, SceneOverviewService) {
                        'ngInject';

                        SceneOverviewService.init();
                        return versionMappingService.recallFunction('getScenes')
                        .then(function(func) {
                            return func();
                        });
                    }

                },
                infoGuide : {
                    state: 'sceneList'
                },
                breadcrumb: {
                    initialState: true,
                    name: 'NAV_Scenes'
                }
            })
            .state('scenesEdit', {
                parent: 'site',
                url: '/scenes/edit',
                templateUrl: 'views/scene/scenes.edit.html',
                controller: 'ScenesEditCtrl',
                resolve: {
                    scenes: function (versionMappingService, SceneOverviewService) {
                        'ngInject';

                        SceneOverviewService.init();
                        return versionMappingService.recallFunction('getScenes')
                        .then(function(func) {
                            return func();
                        });
                    }

                },
                infoGuide : {
                    state: 'sceneList'
                },
                breadcrumb: {
                    initialState: true,
                    name: 'NAV_Scenes'
                }
            });
    }])

    .controller("ScenesCtrl", ['$rootScope', '$scope', '$state', 'scenes', 'viewMenuBarService', '__MenuEntry','xCenterConfig','f_Interval','$q','versionMappingService','API', 'SceneOverviewService','$log', 'importExportSceneService',
        function ($rootScope, $scope, $state, scenes, viewMenuBarService, __MenuEntry,xCenterConfig,f_Interval,$q, versionMappingService, API, SceneOverviewService, $log, importExportSceneService) {

            $scope.scenes = scenes;
            $rootScope.loading = false;
            var intervalId;

            viewMenuBarService.setButtons({
                'homeButton' : true,
                'backButton' : true,
                'sortButton': function () {
                    $state.go('scenesSort');
                },
                'editButton': function () {
                    $state.go('scenesEdit');
                },
                'addButton': function () {
                    // Generate empty guid
                    $state.go('scene.edit', {sceneId: "FFFFFFFF-FFFF-FFFF-FFFF-FFFFFFFFFFFF",sceneList:$scope.scenes});
                },
                'importExportButton': function() {
                    importExportSceneService.setOriginalScenes(scenes);
                    $state.go('scenes.importexport.choice');
                }
            });

            if (xCenterConfig.interval.scenes > 0) {
                var i = {
                    'AppId': 'interval.scenes',
                    delay: xCenterConfig.interval.scenes,
                    fn: function () {
                        var defer = $q.defer();

                        /* Load correct API call based on server version. */
                        versionMappingService.recallFunction('refreshScenes')
                        .then(function(func) {
                            let api = new API();
                            let apiCall = api.Scene[func()]();

                            /* Save API call for future possible cancelation. */
                            SceneOverviewService.activateRefreshOfScenes(apiCall);
                            apiCall.$promise
                            .then(function (data) {
                                /* Once the call is finished, the API call is finished and unnecessary. */
                                SceneOverviewService.deactivateRefreshOfScenes();
                                let self = $scope.scenes;

                                /* Update scenes details with the new data. */
                                for (var j = 0; j < data.length; j++) {
                                    for (var i = 0; i < self.length; i++) {
                                        if (self[i].SceneId === data[j].SceneId) {
                                            self[i].Description = data[j].Description;
                                            self[i].DisplayName = data[j].DisplayName;
                                            self[i].Enabled = data[j].Enabled;
                                            self[i].LastUpdateUtc = data[j].LastUpdateUtc;
                                            self[i].Priority = data[j].Priority;
                                            self[i].SceneState = data[j].SceneState;
                                            self[i].UserLevelRead = data[j].UserLevelRead;
                                            self[i].UserLevelWrite = data[j].UserLevelWrite;

                                            /* Update canView and canRead permissions. */
                                            SceneOverviewService.updateUiPermissions(self);
                                            break;
                                        }
                                    }
                                }
                            }, function () {
                                $log.info('refresh call was canceled');
                            })
                            .finally(function() {
                                /* In case of cancelation, the API call is finished and unnecessary. */
                                SceneOverviewService.deactivateRefreshOfScenes();
                                defer.resolve();
                            });
                        });
                        return defer.promise;
                    }
                };
                intervalId = f_Interval.registerInterval(i);
            }

            $scope.$on("$destroy", function () {
                if (intervalId) {
                    f_Interval.unregisterIntervalByAppId(intervalId);
                }
            });
            var favoriteObject =
            {
                favoriteType: 'MenuEntry',
                favoriteObject: __MenuEntry.$buildRaw({

                    "MenuEntryId": '00000000-0000-0000-0000-000000000005',
                    "MenuEntryType": 3, // For Toggle Favorite to check MenuEntryType.
                    "DeviceId": '00000000-0000-0000-0000-000000000000',
                    'CustomActionName': 'EditScenes',
                    'DisplayName': 'Szenen',
                    'ImageName': 'szene',
                    'CustomActionDatas': {},
                    $UI: {}
                })
            };
            viewMenuBarService.setFavorite(favoriteObject);
        }]
    )


    .controller("ScenesSortCtrl", ['$scope', '$state', '__SceneBase', 'scenes', 'viewMenuBarService',
        function ($scope, $state, __SceneBase, scenes, viewMenuBarService) {

            $scope.scenes = scenes.$encode();

            viewMenuBarService.setButtons({
                'homeButton' : false,
                'backButton' : false,
                'sortButton': function () {
                    $state.go('scenes');
                },

                'sortButtonGreen': true
            });


            $scope.saveOrder = function (scene, indexOld) {
                // calculate the new position of the scene
                var oldPrio = scene.Priority;
                var indexNew;
                for (var i = 0; i < $scope.scenes.length; ++i) {
                    if (scene.SceneId === $scope.scenes[i].SceneId) {
                        indexNew = i;
                        scene.Priority = i > 0 ? ($scope.scenes[i - 1].Priority + 1) : 0;
                        break;
                    }
                }

                // perform save
                __SceneBase.$buildRaw(scene).$updateSceneSettings().$then(function () {
                    __SceneBase.$getAll().$then(function(data){

                        for(var i = 0; i < $scope.scenes.length; i++ )
                        {
                            for(var j = data.length-1; j >=0 ; j-- )
                            {
                                if(data[j].SceneId === $scope.scenes[i].SceneId)
                                {
                                    $scope.scenes[i].Priority =  data[j].Priority;

                                    data.splice(j,1);
                                    break;

                                }
                            }
                        }
                    })
                }, function () {
                    scene.Priority = oldPrio;
                    if (indexOld > indexNew) {
                        indexOld = indexOld - 1;
                    }

                    $scope.scenes.splice(indexNew, 1);
                    $scope.scenes.splice(indexOld, 0, scene);

                });
            };

            $scope.disallowDragBeforeDefaultScene = function(index) {
                return (index === 0 ? false : true);
            };
        }]
    )

    .controller("ScenesEditCtrl", ['$scope', '$state', 'scenes', 'viewMenuBarService', '$q','__SceneBase',
        function ($scope, $state, scenes, viewMenuBarService, $q,__SceneBase) {

            viewMenuBarService.setButtons({
                'homeButton' : false,
                'backButton' : false,
                'revertButton': function () {
                    $state.go('scenes');
                },
                'saveButton': function () {
                    var doList = [];
                    var updateList = [];
                    $scope.$emit('loading-start');
                    for (var i = 0; i < $scope.scenes.length; ++i) {
                        //update changed scenes
                        if ($scope.scenes[i].$UI && $scope.scenes[i].$UI.isChanged && !$scope.scenes[i].$UI.delete) {
                            updateList.push(
                                {
                                    SceneId: $scope.scenes[i].SceneId,
                                    DisplayName: $scope.scenes[i].DisplayName

                                }
                            );
                        }

                        // delete scenes
                        if ($scope.scenes[i].$UI && $scope.scenes[i].$UI.delete) {
                            doList.push(
                                $scope.scenes[i].$destroy().$asPromise()
                            );
                        }
                    }
                    if(updateList.length > 0)
                    {
                        doList.push(
                            __SceneBase.$collection().$updateScenesSettings(updateList).$asPromise()
                        );
                    }
                    if (doList.length > 0) {

                        $q.all(doList).then(function () {
                            $scope.$emit('loading-stop');
                            $state.go('scenes');

                        })
                    } else {
                        $scope.$emit('loading-stop');
                        $state.go('scenes');

                    }
                }
            });

            $scope.scenes = scenes;

            $scope.itemsToDelete = function (scene) {
                return !(scene.$UI && scene.$UI.delete);
            }

        }]
    );

})();
